/*
  Builds the country and market modal the first time someone opens it.

  The modal is 217 kB of markup: 148 flag images, 148 options, 148 buttons and
  a 45 kB language JSON, on every page of the site, hidden until opened. It now
  ships inside a <template>, which the browser parses but does not render: no
  DOM nodes are created, nothing is laid out, and none of the flags are
  fetched. This clones it into the page on first open.

  The open path is global.js's delegated [data-action="toggle-popup"] handler,
  which looks the modal up by the button's aria-controls. So this listens in
  the capture phase, ahead of that handler: if the modal is not in the DOM yet
  it stops the event, clones, and replays the click so the normal path runs
  with the markup present. <localization-selectors> upgrades itself on
  insertion, so nothing else needs wiring.

  The Section Rendering API was tried first and does not work here:
  ?section_id= only renders sections that belong to the requested page's
  template or section groups, so a standalone section file returns 404. Cloning
  a template has no network step at all, so the selector cannot fail.
*/
(function () {
  'use strict';

  var MODAL_ID = 'modal-country';
  var MOUNT_ID = 'localization-modal-mount';
  var TEMPLATE_ID = 'localization-modal-template';
  var TRIGGER = '[data-action="toggle-popup"]';

  function build() {
    if (document.getElementById(MODAL_ID)) return true;

    var tpl = document.getElementById(TEMPLATE_ID);
    var mount = document.getElementById(MOUNT_ID);
    if (!tpl || !mount || !tpl.content) return false;

    mount.appendChild(tpl.content.cloneNode(true));
    mount.removeAttribute('hidden');

    // The template has done its job and is a second copy of 217 kB otherwise.
    if (tpl.parentNode) tpl.parentNode.removeChild(tpl);

    return !!document.getElementById(MODAL_ID);
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target && event.target.closest
        ? event.target.closest(TRIGGER)
        : null;
      if (!button) return;
      if (button.getAttribute('aria-controls') !== MODAL_ID) return;
      if (document.getElementById(MODAL_ID)) return; // already built, carry on

      event.preventDefault();
      event.stopPropagation();

      // Replayed on the next task, not inline. Dispatching from inside this
      // handler nests the click inside the original event's propagation, and
      // global.js's popup handler, which is delegated on body in the bubbling
      // phase, did not act on it: the modal was built but stayed closed until
      // a second click. A macrotask lets the first event finish and the
      // insertion settle, and the open is imperceptible at this distance.
      // If the template is missing the button is left alone rather than sent
      // somewhere that does not exist.
      if (build()) {
        setTimeout(function () {
          button.click();
        }, 0);
      }
    },
    true // capture, so this runs before global.js's delegated handler
  );
})();
